<kendo-appbar style="background-color: #d3d3d3; color: black;position: sticky;z-index: 999" class="header-area">
  <kendo-appbar-section class="showInMobile hambugerMenu">
    <button class="k-button k-button-clear" (click)="sidebar = !sidebar">
      <kendo-icon [name]="'menu'" style="color: black"></kendo-icon>
    </button>
  </kendo-appbar-section>

  <img src="assets/images/tke_small_gradient.png" style="height: 50px" class="showInDesktop">
  <h1 class="title center-title" (click)="navigateToHome()" style="cursor: pointer">Job Files</h1>
  <div class="user-info row showInDesktop" style="position: absolute;right: 3.5em;bottom: 50%">
    <div class="image col-xs-6" style="position: absolute;right: 100%;top: 0.8em;">
      <img src="assets/images/avatar-default-sm.png" width="48" height="48" alt="User"/>
    </div>
    <div class="info-container col-xs-6" [matMenuTriggerFor]="menu">
      <div class="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Welcome {{session?.name}}
        <mat-icon mat-icon-button  style="position: relative;top: 0.3em">keyboard_arrow_down
        </mat-icon>
      </div>
    </div>
  </div>


  <mat-menu #menu="matMenu">
     <span mat-menu-item (click)="navigateToHome()" style="width: 20em; color: #7000BD;">
      <mat-icon>home</mat-icon>
      <span>Home</span>
    </span>
    <span mat-menu-item (click)="signout()" style="width: 20em; color: #7000BD;">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </span>
  </mat-menu>


  <div class="sidebar" style="height: 100vh;color: #003c7d" [ngClass]="sidebar ? 'showSidebar' : ''">
    <div style="height: 100%; background: white;padding: 1em">
      <mat-icon (click)="sidebar = !sidebar" [color]="'primary'" style="float: right">close</mat-icon>
      <div class="row">
        <img src="assets/images/avatar-default-sm.png" width="48" height="48"  class="img-thumbnail" alt="User"/>
        <h6 style="color: #7000BD;font-weight: bold" class="col-8">{{session?.name}}</h6>
      </div>
      <mat-nav-list>
        <mat-list-item style="border-top: 2px solid #003c7d;">
          <button mat-icon-button (click)="navigateToHome()" style="width: 100%;color: #7000BD;">
            <mat-icon >home</mat-icon>
            Home
          </button>
        </mat-list-item>
        <mat-list-item style="border-top: 2px solid #003c7d;border-bottom: 2px solid #003c7d">
          <button mat-icon-button (click)="signout()" style="width: 100%;color: #7000BD;">
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </mat-list-item>
      </mat-nav-list>
      <div class="need-help links text-center" style="margin-top: 10px; color: black;">
        Need Help? please log a ticket on  <a target= "__blank" class="signin" href="https://tke.service-now.com">ServiceNow</a>
      </div>
    </div>
  </div>
</kendo-appbar>

